import React from 'react';
import { StoreProvider } from '../../stores/StoreContext';
import { ReactSession as Session } from './Session';

import '@mdxeditor/editor/style.css'

export const ReactSession = (props) => {
  return (
    <StoreProvider>
      <Session {...props} />
    </StoreProvider>
  );
};